import AccountInfo from '@/app/modules/account/components/account-info/account-info.vue';

export default {
  name: 'account-info-container',
  components: {
    AccountInfo,
  },
};
